module.exports = __webpack_public_path__ + "static/crux_hr-dbc4d471a071563e05203a74aa9e93f6.png";